var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.091,
    height: 46.5,
    viewBox: "0 0 56.091 46.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8acd2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "company",
    d: "M3150.565,9375.569v-2.979H3162.5v-4.77h-6.563v-2.982h6.563v-2.979h-6.563v-2.982h6.563V9355.9h-6.563v-2.979h6.563v-4.77h-11.933v-2.982h14.916v30.4Zm-23.87,0v-41.73h22.079v41.73Zm15.516-11.325v8.346h3.579v-35.771h-16.112v35.771h3.581v-8.346Zm-5.968,8.346h2.984v-5.366h-2.984Zm-26.854,2.979v-30.4h15.516v2.982h-12.532v4.77h7.161v2.979h-7.161v2.979h7.161v2.982h-7.161v2.979h7.161v2.982h-7.161v4.77h11.935v2.979Zm29.837-14.308v-2.979h2.982v2.979Zm-5.968,0v-2.979h2.984v2.979Zm5.968-5.962v-2.98h2.982v2.98Zm-5.968,0v-2.98h2.984v2.98Zm5.968-6.557v-2.981h2.982v2.981Zm-5.968,0v-2.981h2.984v2.981Zm17.3-5.365V9340.4h14.916v2.982Zm-41.175,0V9340.4h15.516v2.982Zm29.837-.6v-2.98h2.982v2.98Zm-5.968,0v-2.98h2.984v2.98Zm-6.565-10.73v-2.981h22.079v2.981Z",
    transform: "translate(-3109.39 -9329.069)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.92c0f741.svg";
export { ForwardRef as ReactComponent };